import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    documentoTipoId: 0,
    documentoTipo: null,
    documentoTipoNombre: null,
    documentoNumero: '',
    direccion: '',
    paisId: 0,
    pais: null,
    paisNombre: null,
    provinciaId: 0,
    provincia: null,
    provinciaNombre: null,
    localidadId: 0,
    localidad: null,
    localidadNombre: null,
    codigoPostal: '',
    telefono: '',
    inactivo: false,
    rowVersion: null,

    destinoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_DESTINO' (state, remitoDestinoId) {
        state.id = remitoDestinoId;
        state.nombre = '';
        state.documentoTipoId = 0;
        state.documentoTipo = null;
        state.documentoTipoNombre = null;
        state.documentoNumero = '';
        state.direccion = '';
        state.paisId = 0;
        state.pais = null;
        state.paisNombre = null;
        state.provinciaId = 0;
        state.provincia = null;
        state.provinciaNombre = null;
        state.localidadId = 0;
        state.localidad = null;
        state.localidadNombre = null;
        state.codigoPostal = '';
        state.telefono = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_DESTINO' (state, destino) {
        state.nombre = destino.nombre.toUpperCase().trim();
        state.documentoTipoId = destino.documentoTipo? destino.documentoTipo.id : 0;
        state.documentoTipo = destino.documentoTipo;
        state.documentoTipoNombre = destino.documentoTipo? destino.documentoTipo.nombre.trim() : null;
        state.documentoNumero = destino.documentoNumero.trim();
        state.direccion = destino.direccion.toUpperCase().trim();
        state.paisId = destino.pais? destino.pais.id : 0;
        state.pais = destino.pais;
        state.paisNombre = destino.pais? destino.pais.nombre.trim() : null;
        state.provinciaId = destino.provincia? destino.provincia.id : 0;
        state.provincia = destino.provincia;
        state.provinciaNombre = destino.provincia? destino.provincia.nombre.trim() : null;
        state.localidadId = destino.localidad? destino.localidad.id : 0;
        state.localidad = destino.localidad;
        state.localidadNombre = destino.localidad? destino.localidad.nombre.trim() : null;
        state.codigoPostal = destino.codigoPostal.toUpperCase().trim();
        state.telefono = destino.telefono;
        state.inactivo = destino.inactivo;
        state.rowVersion = destino.rowVersion;
    },
    'SET_DESTINO_ID' (state, destino) {
        state.id = destino.id;
        state.rowVersion = destino.rowVersion;
    },
    'SET_DOCUMENTOTIPO'(state, documentoTipo) {
        state.documentoTipoId= documentoTipo? parseInt(documentoTipo.id) : 0;
        state.documentoTipo = documentoTipo;
        state.documentoTipoNombre = documentoTipo? documentoTipo.nombre.trim() : null;
    },
    'SET_PAIS'(state, pais) {
        state.pais = pais;
        if (pais) {
            state.paisId= pais.id? parseInt(pais.id) : 0;
            state.paisNombre = pais.nombre? pais.nombre.trim() : null;
        } else {
            state.paisId= 0;
            state.paisNombre = null;
        }
    },
    'SET_PROVINCIA'(state, provincia) {
        state.provincia = provincia;
        if (provincia) {
            state.provinciaId= provincia.id? parseInt(provincia.id) : 0;
            state.provinciaNombre = provincia.nombre? provincia.nombre.trim() : null;
        } else {
            state.provinciaId= 0;
            state.provinciaNombre = null;
        }
    },
    'SET_LOCALIDAD'(state, localidad) {
        state.localidad = localidad;
        if (localidad) {
            state.localidadId= localidad.id? parseInt(localidad.id) : 0;
            state.localidadNombre = localidad.nombre? localidad.nombre.trim() : null;
        } else {
            state.localidadId= 0;
            state.localidadNombre = null;
        }
    },

    'INICIALIZAR_DATOS'(state) {
        state.destinoDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.destinoDatos = params.destinoDatos;
    },
};

const getters = {
    getField,

    remitoDestino(state) {
        return {
            id: state.id,
            documentoTipo: state.documentoTipoNombre.trim(),
            documentoNumero: state.documentoNumero.trim(),
            nombre: state.nombre.toUpperCase().trim(),
            direccion: state.direccion.toUpperCase().trim(),
            localidad: state.localidadNombre.trim(),
            provincia: state.provinciaNombre.trim(),
            pais: state.paisNombre.trim(),
            codigoPostal: state.codigoPostal.toUpperCase().trim(),
            telefono: state.telefono.toUpperCase().trim(),
        }
    }
};

const actions = {
    inicializar ( { commit }, remitoDestinoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DESTINO', remitoDestinoId);
            
            if (remitoDestinoId != 0) {
                apiAxios.get('remitosdestinos/' + remitoDestinoId + '/abm' ) 
                .then(res => {
                    commit('SET_DESTINO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            /*
            let fechaNacimiento = '1900-01-01';
            if ((/true/i).test(state.fechaNacimientoHabilitada)) {
                fechaNacimiento = moment(state.fechaNacimiento).format('YYYY-MM-DD');
            }
            */

            let destino= {
                nombre: state.nombre.toUpperCase().trim(),
                documentoTipoId: state.documentoTipoId,
                documentoNumero: state.documentoNumero.trim(),
                direccion: state.direccion.toUpperCase().trim(),
                paisId: state.paisId,
                provinciaId: state.provinciaId,
                localidadId: state.localidadId,
                codigoPostal: state.codigoPostal.toUpperCase().trim(),
                telefono: state.telefono.toUpperCase().trim(),
                inactivo: state.inactivo,
            }

            let url = 'remitosdestinos';
            if (state.id != 0) {
                url += "/" + state.id;
                destino.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, destino)
                .then((res) => {
                    /* Actualizamos Id y RowVersion */
                    commit('SET_DESTINO_ID', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setDocumentoTipo: ({commit}, documentoTipo) => {
        commit('SET_DOCUMENTOTIPO', documentoTipo);
    },
    setPais: ({commit}, pais) => {
        commit('SET_PAIS', pais);
    },
    setProvincia: ({commit}, provincia) => {
        commit('SET_PROVINCIA', provincia);
    },
    setLocalidad: ({commit}, localidad) => {
        commit('SET_LOCALIDAD', localidad);
    },
    inactivar ( { }, destinoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('remitosdestinos/' + destinoId + '/inactivar')
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, remitoDestinoId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            if (remitoDestinoId) {
                if (remitoDestinoId != 0) {
                    apiAxios.get('remitosdestinos/' + remitoDestinoId ) 
                    .then(res => {
                        let destinoDatos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'documentoTipo', 'campo': 'Tipo Doc.', 'valor': res.data.documentoTipo, 'formato': '' },
                            { 'nombre': 'documentoNumero', 'campo': 'Nro. Doc', 'valor': res.data.documentoNumero, 'formato': '' },
                            { 'nombre': 'direccion', 'campo': 'Direccion', 'valor': res.data.direccion, 'formato': '' },
                            { 'nombre': 'pais', 'campo': 'Pais', 'valor': res.data.pais, 'formato': '' },
                            { 'nombre': 'provincia', 'campo': 'Provincia', 'valor': res.data.provincia, 'formato': '' },
                            { 'nombre': 'localidad', 'campo': 'Localidad', 'valor': res.data.localidad, 'formato': '' },
                            { 'nombre': 'codigoPostal', 'campo': 'Cod.Postal', 'valor': res.data.codigoPostal, 'formato': '' },
                            { 'nombre': 'telefono', 'campo': 'Teléfono', 'valor': res.data.telefono, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                        ];
                        
                        let params = {
                            destinoDatos
                        };

                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));                
                } else {
                    resolve();
                }
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}